import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnerPageTemplate from "@/components/partners/PartnerPageTemplate";
import { chenoaFund } from "@/data/partners";

export const Route = createFileRoute("/partners/chenoa-fund")({
  head: () => seoHead("/partners/chenoa-fund"),
  component: () => <PartnerPageTemplate partner={chenoaFund} />,
});
